import React from "react";

export default function AuthorBox({ post }) {
    if (!post) {
        return (
            <div className="author-box">
                <div className="inner">
                    <p>Loading…</p>
                </div>
            </div>
        );
    }

    const avatarSrc = post.post_admin_logo || '/kds-assets/img/kudosta-icon.png';

    return (
        <div className="author-box">
            <div className="inner">
                <span className="avatar">
                    <img src={avatarSrc} alt={post.author || 'Kudosta Team'} />
                </span>
                <div>
                    <div className="n">{post.author || 'Kudosta Team'}</div>
                    <p>{post.author_bio || 'We design and build custom software for businesses that outgrew the template.'}</p>
                </div>
            </div>
        </div>
    );
}
